import React, { useState } from 'react';
import Header from './Components/Header/header';
import StepProgressBar from './UIElements/stepProgressbar';

// Step Components
import LoanPreApproval from './Components/LeadCaptureForm/LoanPreApproval';
import TermsAndConditions from './Components/TermsCondition/TermsCondition';
import CustomizeLoan from './Components/CustomizeLoan/customloan';
import Spinner from './Components/Spinner/spinner';
import { KYCRedirectScreen } from './Components/kycloadingscreen';
import ResidentialDetailsForm from './Components/LeadCaptureForm/ResidentialDetails';
import WorkDetailsForm from './Components/LeadCaptureForm/WorkDetailsForm';
import LoanReview from './Components/LoanReview/loanReview';
import LoanReviewPage2 from './Components/LoanReview2/loanReview2';
import LoanApproved from './Components/Loan-Approved/loanApproved';

const TOTAL_STEP = 9;

function PostOfferPages() {
  const [currentStep, setCurrentStep] = useState(1);

  const renderStepComponent = () => {
    switch (currentStep) {
      case 1:
        return <LoanPreApproval setCurrentStep={setCurrentStep} />;
      case 2:
        return <TermsAndConditions setCurrentStep={setCurrentStep} />;
      case 3:
        return <CustomizeLoan setCurrentStep={setCurrentStep} />;
      case 4:
        return <KYCRedirectScreen setCurrentStep={setCurrentStep} message={'We are redirecting you \n to complete your KYC.'} />;
      case 5:
        return <ResidentialDetailsForm setCurrentStep={setCurrentStep} />;
      case 6:
       return <WorkDetailsForm setCurrentStep={setCurrentStep} />;
     
        
      case 7:
        return (
          <LoanReview
            setCurrentStep={setCurrentStep}
            loanAmount={10000}
            feesAmount={798}
            accountAmount={9292}
            emiCount={18}
            monthlyEmi={633}
            feesDetails={[
              { label: 'One Time Processing Fees', amount: 633 },
              { label: 'Taxes (GST)', amount: 198 },
            ]}
            onNext={() => setCurrentStep(8)}
          />
        );
      case 8:
        return <LoanReviewPage2 setCurrentStep={setCurrentStep} />;
      case 9:
         return <KYCRedirectScreen setCurrentStep={setCurrentStep} message={'Give us a few \n seconds to process \n your application'} />;
      case 10:
        return <LoanApproved setCurrentStep={setCurrentStep} />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full max-w-[400px] h-fit">
      {!(currentStep === 4 || currentStep === 9)&& <Header />}
      {!(currentStep === 4 || currentStep === 9)&&<StepProgressBar currentStep={currentStep} totalSteps={TOTAL_STEP} />}
      <div className="mt-6">{renderStepComponent()}</div>
    </div>
  );
}

export default PostOfferPages;
